// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"68309e2e","455":"2de00cf2","488":"77a874cc"}[chunkId] + ".chunk.js";
};